import React, { useEffect, useState } from "react";
import { Checkbox, Form, message } from "antd";
import { SaveButton, InputText, InputTextArea, CancelButton, ModalComponent, trans } from "@comps/components"
import { makeRequest, getErrorProps } from "@utils/helpers";
import { createDataReq } from "../requests";
import { Commons, Const, Validations } from "../../../constants";
import { makeFieldLabel } from "@utils/fieldTooltips";
import { masterTooltips } from "../../../../common/masterTooltips";
const langKey = Const["bloodGroup"].lngKey
const fieldLabel = makeFieldLabel(masterTooltips.lookup, { namespace: "lookup", label: (key) => trans(`${langKey}.${key}`) });
const formName = "createBloodGroup";

const CreateBloodGroup = (props) => {
  const [loader, setLoader] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false);
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    // eslint-disable-next-line
  }, []);

  const onSubmit = (data) => {
    setSaveLoader(true)
    const payload = { blood_group: data };
    makeRequest(setLoader, createDataReq, payload, onSuccess, onError);
  }

  const onSuccess = (data, res) => {
    setSaveLoader(false)
    message.success("Saved successfully");
    props.onCompleted(data.blood_groups.data);
    props.onSuccess(data)
  }

  const onError = (err, res) => {
    setSaveLoader(false)
    message.error(res.response.data.message);
  }

  //-----------------------
  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------

  const footer = [
    <SaveButton loading={ saveLoader } form={ formName } key="create_button" htmlType="submit" />,
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];

  // ------------------------------------
  // Eend footer buttons array
  // ------------------------------------

  return (
    <ModalComponent top={ 20 } width={ 600 } maskClosable={ false }
      mainTitle={ trans(Commons.create) } subTitle={ trans(`${langKey}.moduleName`) }
      visible={ true } footer={ footer } onCancel={ () => props.onCompleted(false) }>
      <Form { ...formLayout } name={ formName } onFinish={ onSubmit } scrollToFirstError>

        <Form.Item name="name" rules={ rules.name } label={ fieldLabel("name", trans(Commons.name)) }
          className="da-mb-16"
          { ...getErrorProps(errors['name']) } size="small"
        >
          <InputText placeholder={ trans(`${langKey}.name`) } />
        </Form.Item>

        <Form.Item name="is_active" valuePropName="checked" rules={ rules.is_active } label={ fieldLabel("is_active", trans(Commons.is_active)) }
          className="da-mb-16"
          { ...getErrorProps(errors['is_active']) } size="small"
        >
          <Checkbox defaultChecked />
        </Form.Item>

        <Form.Item name="description" rules={ rules.description } label={ fieldLabel("description", trans(Commons.description)) }
          className="da-mb-16"
          { ...getErrorProps(errors['description']) } size="small"
        >
          <InputTextArea placeholder={ trans(`${langKey}.description`) } />
        </Form.Item>

      </Form>
    </ModalComponent>
  )
}

export default CreateBloodGroup

const rules = {
  name: [
    { required: true, message: trans(Validations.name) },
  ],

};

const formLayout = {
  // layout: "horizontal",
  labelCol: { span: 6 },
  wrapperCol: { span: 14, offset: 2 },
  labelAlign: "left"
}